import $ from 'jquery';
import { SetupFunction } from 'vue';
import { trans } from '@/domain/dao/Translations';
import { useApiUnreadCount } from '@/lib/components/Shared/AnnounceKitIcon.api';
import { useContainer } from '@/domain/services/Container';
import { VueHooks } from '@/domain/services/VueHooks';
import { CounterProps, CounterView, useCounter } from '@/lib/components/Shared/Counter.composable';

const announceKitIconController: SetupFunction<CounterProps, CounterView> = (props): CounterView => {
	const { onMounted } = useContainer<VueHooks>();
	const { getUnreadCount } = useApiUnreadCount();
	const getCount = async () => (await getUnreadCount())?.unread || 0;
	const { count, showCounter, refreshCounter } = useCounter({
		counterUrl: props.url,
		getCount,
		hideCounterAtUrl: props.hideCounterAtUrl,
	});

	onMounted(refreshCounter);
	$(document).on('pjax:end', refreshCounter);

	return {
		count,
		showCounter,
		title: trans().get('miscellaneous.updates'),
		icon: 'af-icons-new',
	};
};

export { announceKitIconController };
